module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 13
// module chunks = 0 1 2 3 4 5 7